(function () {
  function loadRecommendations(section) {
    fetch(section.dataset.url)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        if (!text) return;
        var html = new DOMParser().parseFromString(text, 'text/html');
        var freshGrid = html.querySelector('[data-product-recommendations] .product-grid__grid');
        var grid = section.querySelector('.product-grid__grid');
        if (!freshGrid || !grid || !freshGrid.querySelector('.product-grid__item')) return;
        grid.innerHTML = freshGrid.innerHTML;
        section.hidden = false;
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      if (section.dataset.recommendationsLoaded) return;
      section.dataset.recommendationsLoaded = 'true';

      if (section.hidden || !('IntersectionObserver' in window)) {
        loadRecommendations(section);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations(section);
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(section);
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
